var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "itemstore" } },
    [
      _c("div", { staticClass: "bg" }),
      _c(
        "div",
        { staticClass: "flex flex-center-1", staticStyle: { width: "100%" } },
        [
          _c("div", { staticClass: "shop-tab flex flex-center-1" }, [
            _vm.$canShowFeature("shop_vip")
              ? _c(
                  "div",
                  {
                    staticClass: "shop-tab-item flex flex-center-1",
                    class: {
                      "shop-tab-item-active": _vm.currentShopType === "shopVip",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onGotoShop("shopVip")
                      },
                    },
                  },
                  [_vm._v(" KJ商城 ")]
                )
              : _vm._e(),
            _vm.$canShowFeature("shop_uu")
              ? _c(
                  "div",
                  {
                    staticClass: "shop-tab-item flex flex-center-1",
                    class: {
                      "shop-tab-item-active": _vm.currentShopType === "shopUu",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onGotoShop("shopUu")
                      },
                    },
                  },
                  [_vm._v(" 商城二 ")]
                )
              : _vm._e(),
            _vm.$canShowFeature("shop_coin1")
              ? _c(
                  "div",
                  {
                    staticClass: "shop-tab-item flex flex-center-1",
                    class: {
                      "shop-tab-item-active":
                        _vm.currentShopType === "shopCoin1",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onGotoShop("shopCoin1")
                      },
                    },
                  },
                  [_vm._v(" 金豆商城 ")]
                )
              : _vm._e(),
            _vm.$canShowFeature("shop_happycoin")
              ? _c(
                  "div",
                  {
                    staticClass: "shop-tab-item flex flex-center-1",
                    class: {
                      "shop-tab-item-active":
                        _vm.currentShopType === "shopHappyCoin",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onGotoShop("shopHappyCoin")
                      },
                    },
                  },
                  [_vm._v(" 欢乐豆商城 ")]
                )
              : _vm._e(),
            _vm.$canShowFeature("shop_gold")
              ? _c(
                  "div",
                  {
                    staticClass: "shop-tab-item flex flex-center-1",
                    class: {
                      "shop-tab-item-active":
                        _vm.currentShopType === "shopGold",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onGotoShop("shopGold")
                      },
                    },
                  },
                  [_vm._v(" 商城一 ")]
                )
              : _vm._e(),
          ]),
        ]
      ),
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "mall-tab-link" }, [
          _c(
            "div",
            { staticClass: "com-tab-block flex flex-ver" },
            _vm._l(_vm.list_assets_data.categories, function (item, index) {
              return _c(
                "div",
                {
                  staticClass: "item",
                  class: [item.id === _vm.category ? "active" : ""],
                  on: {
                    click: function ($event) {
                      return _vm.switchType(item.id)
                    },
                  },
                },
                [
                  _c("img", { attrs: { src: item.imgUrl } }),
                  _c("p", { staticClass: "text" }, [
                    _vm._v(" " + _vm._s(item.name)),
                  ]),
                  item.sub_catetory.length > 0
                    ? _c(
                        "div",
                        { staticClass: "sub-catetory" },
                        _vm._l(
                          item.sub_catetory,
                          function (subitem, sub_index) {
                            return _c(
                              "a",
                              {
                                class: [
                                  item.id === _vm.category &&
                                  _vm.sub_catetoryId === sub_index
                                    ? "sub_active"
                                    : "",
                                ],
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.searchSubCat(
                                      subitem,
                                      sub_index,
                                      index
                                    )
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(subitem) + " ")]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
        ]),
        _c(
          "div",
          { staticClass: "mall-filter-con" },
          [
            _c("div", { staticClass: "balance" }, [
              _vm._v("商城可用余额: "),
              _c("img", {
                staticClass: "curreny",
                attrs: {
                  src: require("@/assets/images/home_new/currency.png"),
                  width: "12",
                  height: "12",
                },
              }),
              _c("span", [
                _vm._v(_vm._s(_vm._f("conversion")(_vm.user.recycles))),
              ]),
            ]),
            _c("div", { staticClass: "input" }, [
              _c("form", { attrs: { action: "", "auto-complete": "off" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search_name,
                      expression: "search_name",
                    },
                  ],
                  attrs: { type: "text", placeholder: "按名称搜索" },
                  domProps: { value: _vm.search_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.search_name = $event.target.value
                    },
                  },
                }),
                _c("input", {
                  staticStyle: { height: "0", width: "0" },
                  attrs: { type: "text" },
                }),
              ]),
              _c("img", {
                attrs: {
                  src: require("@/assets/icons/interchange_search_icon.png"),
                  alt: "",
                },
                on: { click: _vm.getList },
              }),
            ]),
            _c(
              "Select",
              {
                on: { "on-change": _vm.getList },
                model: {
                  value: _vm.price_range,
                  callback: function ($$v) {
                    _vm.price_range = $$v
                  },
                  expression: "price_range",
                },
              },
              [
                _c("Option", { attrs: { value: 0 } }, [_vm._v("不限")]),
                _c("Option", { attrs: { value: 1 } }, [_vm._v("0-50")]),
                _c("Option", { attrs: { value: 2 } }, [_vm._v("50-200")]),
                _c("Option", { attrs: { value: 3 } }, [_vm._v("200-1000")]),
                _c("Option", { attrs: { value: 4 } }, [_vm._v("1000-2000")]),
                _c("Option", { attrs: { value: 5 } }, [_vm._v("2000-10000")]),
                _c("Option", { attrs: { value: 6 } }, [_vm._v("10000+")]),
              ],
              1
            ),
            _c(
              "div",
              {
                class: ["sort", _vm.sort_price ? "" : "active"],
                on: { click: _vm.sortPrice },
              },
              [
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.sort_price ? "↓ 价格从低到高" : "↑ 价格从高到低")
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mall-item-list" },
          [
            _c(
              "ul",
              { staticClass: "list" },
              _vm._l(_vm.active_produce_list, function (item) {
                return _vm.active_produce_list.length > 0
                  ? _c(
                      "li",
                      {
                        key: item.id,
                        on: {
                          click: function ($event) {
                            return _vm.openBuyModal(item)
                          },
                        },
                      },
                      [
                        _c("c-award", {
                          staticClass: "award",
                          attrs: {
                            rarity: item.item.rarity,
                            picture: item.item.itemPic,
                            name: item.item.name,
                            price: item.price,
                            width: "100%",
                          },
                        }),
                        _c("div", { staticClass: "item-footer" }, [
                          _c("div", { staticClass: "price" }, [
                            _c("img", {
                              staticClass: "curreny",
                              attrs: {
                                src: require("@/assets/images/home_new/currency.png"),
                                width: "12",
                                height: "12",
                              },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("conversion")(item.price)) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "btn" }, [
                            _vm._v(
                              _vm._s(
                                _vm.currentShopType === "shopVip" ||
                                  _vm.currentShopType === "shopHappyCoin" ||
                                  _vm.currentShopType === "shopCoin1"
                                  ? "购买"
                                  : "购买并发货"
                              )
                            ),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e()
              }),
              0
            ),
            _vm.totalPage > 1
              ? _c("Page", {
                  attrs: {
                    current: _vm.page,
                    total: _vm.totalItems,
                    "page-size": _vm.pageSize,
                    "class-name": "page",
                  },
                  on: {
                    "update:current": function ($event) {
                      _vm.page = $event
                    },
                    "on-change": _vm.pageF,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal",
            "footer-hide": "",
            width: "'400rem'",
            closable: false,
          },
          model: {
            value: _vm.confirm_modal.flag,
            callback: function ($$v) {
              _vm.$set(_vm.confirm_modal, "flag", $$v)
            },
            expression: "confirm_modal.flag",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "确认要购买吗？", has_close_button: "" },
              on: {
                close_button_click: function () {
                  return (_vm.confirm_modal.flag = false)
                },
              },
            },
            [
              _c("div", { staticClass: "app-form" }, [
                _c(
                  "p",
                  {
                    staticClass: "cart_buy_item_modal_desc flex flex-center-1",
                  },
                  [
                    _vm._v(" 将会花费 "),
                    _c("span", { staticClass: "price-text" }, [
                      _vm._v(
                        _vm._s(_vm._f("conversion")(_vm.confirm_modal.price)) +
                          " "
                      ),
                      _c("img", {
                        staticClass: "curreny",
                        attrs: {
                          src: require("@/assets/images/home_new/currency.png"),
                          width: "12",
                          height: "12",
                        },
                      }),
                    ]),
                    _vm._v(" 以支付此物品 "),
                  ]
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "submit-button",
                  staticStyle: { width: "100%", "border-radius": "100px" },
                  on: { click: _vm.submit_buy },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.currentShopType === "shopVip" ||
                          _vm.currentShopType === "shopHappyCoin" ||
                          _vm.currentShopType === "shopCoin1"
                          ? "购买"
                          : "购买并发货"
                      ) +
                      " "
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "'438rem'",
            closable: false,
          },
          model: {
            value: _vm.notice_modal_show,
            callback: function ($$v) {
              _vm.notice_modal_show = $$v
            },
            expression: "notice_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: {
                title:
                  _vm.currentShopType === "shopVip" ? "KJ商城说明" : "商城说明",
                has_close_button: "",
              },
              on: {
                close_button_click: function () {
                  _vm.notice_modal_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content" }, [
                _c("p", [_vm._v(" 商城，目前支持VIP3及以上客户进行购买。 ")]),
                _c("br"),
                _c("p", [
                  _vm._v(" 商城旨在为JH的忠实用户提供最实惠的饰品购买体验。 "),
                ]),
                _c("br"),
                _c("p", [
                  _vm._v(" 目前商城，通过UU、扎比特、自营 等方式发货。 "),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }